export default "/_next/static/images/44/presentation-44e9104df8879f0b3e1a97289f77a0ee.jpg";